











































































import { Component, Watch, Vue, Mixins } from 'vue-property-decorator';

import membersApi from '@/api/members';

import {
  InvestmentQualifications,
  InvestmentRequirementValue,
  InvestmentRequirementKey
} from './enum';
import { delay } from '../../utils';

import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component
export default class InvestmentUploadSelect extends Vue {
  @userModule.Getter
  requesterId!: string;

  requirementActive = false;

  requirement: InvestmentRequirementKey | '' = '';
  qualification: InvestmentQualifications = InvestmentQualifications.ordinary;

  InvestmentQualifications = InvestmentQualifications;
  InvestmentRequirementValue = InvestmentRequirementValue;

  get isDisabled(): boolean {
    if (this.requirement) {
      return false;
    }
    return true;
  }

  goNext() {
    this.$router.push({
      name: 'investment-upload-file',
      params: {
        type: this.requirement
      }
    });
  }
}
